// Snackbar.js
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import MDSnackbar from "components/MDSnackbar";
import PropTypes from "prop-types";

const AppSnackbar = ({ open, type, message, onClose }) => {
  function getIcon() {
    switch (type) {
      case "success":
        return "check";
      case "notifications":
        return "notifications";
      case "warning":
        return "star";
      case "error":
        return "warning";
      default:
        return "check";
    }
  }

  return (
    <MDSnackbar
      color={type}
      icon={getIcon()}
      title={message}
      // content={message}
      autoHideDuration={4000}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      open={open}
      onClose={onClose}
      close={onClose}
    />
  );
};

export default AppSnackbar;

AppSnackbar.propTypes = {
  type: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
